import { isFileEditCompleteResult, type ToolCallResultPayload } from '@air/feature-ag-ui-chat';

import { getResultsPerTarget } from './consumeTransformTargetSourceNodeId';

/**
 * A joined multi-target transform runs in parallel and delivers every result in one
 * `file_edit_complete`, ordered by target. Splits that call into one payload per target
 * so each result lands on its own node. Per-target deliveries and single-target sends
 * pass through unchanged.
 */
export const splitMultiTargetFileEdit = (payload: ToolCallResultPayload): ToolCallResultPayload[] => {
  const { programmaticOptions } = payload;
  const targetNodeIds = programmaticOptions?.transformTargetNodeIds;

  if (!programmaticOptions || !targetNodeIds || targetNodeIds.length <= 1 || !isFileEditCompleteResult(payload)) {
    return [payload];
  }

  const { edits } = payload.toolCallResult;
  const targetCount = targetNodeIds.length;
  const resultsPerTarget = getResultsPerTarget(programmaticOptions);

  let chunkSize: number | undefined;

  if (edits.length > 1 && edits.length === targetCount) {
    chunkSize = 1;
  } else if (edits.length > resultsPerTarget) {
    chunkSize = resultsPerTarget;
  } else {
    return [payload];
  }

  const sharedOptions = { ...programmaticOptions, transformTargetNodeIds: undefined };
  const payloads: ToolCallResultPayload[] = [];

  for (let start = 0; start < edits.length; start += chunkSize) {
    const targetNodeId = targetNodeIds[start / chunkSize];

    payloads.push({
      ...payload,
      programmaticOptions: targetNodeId ? { ...sharedOptions, sourceNodeId: targetNodeId } : sharedOptions,
      toolCallResult: { ...payload.toolCallResult, edits: edits.slice(start, start + chunkSize) },
    });
  }

  return payloads;
};
